"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseError = exports.RequestError = exports.CustomError = exports.isResponseErrorResult = exports.isRequestErrorResult = exports.isErrorResult = void 0;
const customErrors = ["request", "response"];
const objectifyError = (err) => (Object.getOwnPropertyNames(err).reduce((acc, key) => (Object.assign(acc, {
    [key]: err[key],
})), {}));
const isErrorResult = (result) => {
    var _a, _b, _c;
    return (((_a = result) === null || _a === void 0 ? void 0 : _a.type) === "error" &&
        !!((_b = result) === null || _b === void 0 ? void 0 : _b.data) &&
        !!((_c = result) === null || _c === void 0 ? void 0 : _c.data.originalError));
};
exports.isErrorResult = isErrorResult;
const isCustomError = (result) => (result instanceof CustomError &&
    customErrors.includes(result._type));
const isCustomErrorType = (result, type) => (((0, exports.isErrorResult)(result) &&
    isCustomError(result.data.originalError) &&
    result.data.originalError._type === type) || (isCustomError(result) &&
    result._type === type));
const isRequestErrorResult = (result) => (isCustomErrorType(result, "request"));
exports.isRequestErrorResult = isRequestErrorResult;
const isResponseErrorResult = (result) => (isCustomErrorType(result, "response"));
exports.isResponseErrorResult = isResponseErrorResult;
class CustomError extends Error {
    constructor(message, originalError, type) {
        super(message);
        Object.assign(this, objectifyError(originalError), {
            message,
            originalError,
        });
        this._type = type;
    }
    toJSON() {
        return objectifyError(this);
    }
}
exports.CustomError = CustomError;
class RequestError extends CustomError {
    constructor(message, originalError, body) {
        super(message, originalError, "request");
        this.body = body;
    }
}
exports.RequestError = RequestError;
class ResponseError extends CustomError {
    constructor(message, originalError, body) {
        super(message, originalError, "response");
        this.body = body;
    }
}
exports.ResponseError = ResponseError;
//# sourceMappingURL=errors.js.map